<mat-accordion>
    <ng-container *ngFor="let accordion of accordions">
        <mat-expansion-panel (opened)="panelOpened(accordion?.id)">
            <mat-expansion-panel-header>
                <mat-panel-title>{{accordion?.label}}</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container [ngSwitch]="accordion?.id">
                <ng-container *ngSwitchCase="'BENEFICIARY'">
                    <app-policy-beneficiary [list]="beneficiaries"
                        [policyType]="policyType"></app-policy-beneficiary>
                </ng-container>
                <!-- <ng-container *ngSwitchCase="'SHARES'">
                  <app-policy-quote [counterValue]="detail.policyValue.insuredAmount" [shareList]="detail.intesaFurtherDetails.uni30.quote"></app-policy-quote>
                </ng-container> -->
                <ng-container *ngSwitchCase="'MOVEMENTS'">
                  <app-policy-patrimonio-movimenti [retrievedQuote]="retrievedQuote" (retrieveQuote)="getQuote($event)" [policyDetail]="detail"></app-policy-patrimonio-movimenti>
                </ng-container>
                <ng-container *ngSwitchCase="'TRANSFERS'">
                  <app-policy-trasferimenti [trasferimentiInIngresso]="trasferimentiInIngresso" [trasferimentiTfr]="trasferimentiTfr" [trasferimentiTecnici]="trasferimentiTecnici"></app-policy-trasferimenti>
                </ng-container>
                <ng-container *ngSwitchCase="'SWITCH'">
                  <app-policy-switch [detail]="detail"></app-policy-switch>
                </ng-container>
                <ng-container *ngSwitchCase="'ESTEMPORANEI'">
                  <app-policy-estemporanei [detail]="detail"></app-policy-estemporanei>
                </ng-container>
                <ng-container *ngSwitchCase="'FISCALCARD'">
                  <app-policy-scheda-fiscalita [detail]="detail"></app-policy-scheda-fiscalita>
                </ng-container>
                <ng-container *ngSwitchCase="'ACCIDENTS'">
                    <h6>Non risultano sinistri aperti</h6>
                </ng-container>
                <ng-container *ngSwitchCase="'DOCUMENTS'">
                  <app-policy-documents [documentsList]="policyDocuments"></app-policy-documents>
                </ng-container>
                <ng-container *ngSwitchCase="'TUTOR'">
                    <ng-container *ngIf="legalSubjectsKeys">
                      <ng-container *ngFor="let key of legalSubjectsKeys">
                        <div class="detail-box">
                          <ng-container *ngFor="let objectKey of formattedLegalSubjectKeys[key]">
                            <div class="detail-item">
                              <p class="detail-label">{{objectKey?.label}}</p>
                              <h6 *ngIf="objectKey?.key; else detailDefaultValue" [ngClass]="{'hidden-input-field': objectKey.hidden && hidePersonalData}">{{ getValueByPath(detail.legalSubjects[key], objectKey) }}</h6>
                              <ng-template #detailDefaultValue>
                                <h6>{{ objectKey?.defaultValue }}</h6>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                <ng-container *ngSwitchDefault>
                    <div class="detail-box">
                        <ng-container *ngFor="let item of accordion?.keys; let isLast = last; let i = index;">
                            <ng-container *ngIf="item?.type !== 'TABLE'">
                                <div class="detail-item">
                                    <p class="detail-label">{{item?.label}}</p>
                                    <h6 *ngIf="item?.key; else detailDefaultValue" [ngClass]="{'hidden-input-field': item.hidden && hidePersonalData}">{{ getValueByPath(detail, item) }}</h6>
                                    <ng-template #detailDefaultValue>
                                        <h6>{{ item?.defaultValue }}</h6>
                                    </ng-template>
                                </div>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngFor="let placeholder of getPlaceholders(accordion)">
                            <div class="detail-item"></div>
                        </ng-container>
                        <ng-container *ngIf="getTableItem(accordion)">
                          <div class="detail-item-table">
                            <ng-container *ngIf="getTableList(accordion) as tableList; ">
                              <ng-container *ngIf="tableList.length ;else emptyState">
                                <ng-container *ngIf="getTableItem(accordion) as tableItem">
                                  <p class="detail-label">{{ tableItem.label }}</p>
                                  <app-policy-table [keys]="tableItem.tableKeys" [list]="tableList">
                                  </app-policy-table>
                                </ng-container>
                              </ng-container>
                              <ng-template #emptyState>
                                <ng-container *ngIf="getTableItem(accordion) as tableItem">
                                  <h6>{{ tableItem.emptyStateMessage }}</h6>
                                </ng-container>
                              </ng-template>
                            </ng-container>
                          </div>
                        </ng-container>
                    </div>
                </ng-container>
            </ng-container>
        </mat-expansion-panel>
    </ng-container>
</mat-accordion>
